import {getDateTime, moment} from "@/src/modules/core/lib";

import {BREAK_RULES, BREAK_RULE_DEFAULT} from "../lib";
import {TemplateSchema} from "../types";

class TemplateValidator {
  getShiftDuration(from_time: string, to_time: string) {
    if (!from_time || !to_time) {
      return 0;
    }
    const date = moment().format("YYYY-MM-DD");

    const fromDateTime = getDateTime(date, from_time);
    let toDateTime = getDateTime(date, to_time);
    if (toDateTime.isBefore(fromDateTime)) {
      toDateTime.add(1, "day");
    }
    const shiftDuration = toDateTime.diff(fromDateTime, "hours", true);
    return shiftDuration;
  }

  getBreaksRule(from_time: string, to_time: string) {
    if (!from_time || !to_time) {
      return BREAK_RULE_DEFAULT;
    }

    const shiftDuration = this.getShiftDuration(from_time, to_time);
    const [_, rule] = BREAK_RULES.find(([duration]) => duration <= shiftDuration) ?? [
      0,
      BREAK_RULE_DEFAULT,
    ];
    return rule;
  }

  validateTemplateRequiredBreaks(template: TemplateSchema) {
    const rule = this.getBreaksRule(template.from_time, template.to_time);
    const restBreaks = template.breaks.filter((breakItem) => breakItem.break_type === "rest");
    const lunchBreaks = template.breaks.filter((breakItem) => breakItem.break_type === "lunch");
    return restBreaks.length >= rule?.rest && lunchBreaks.length >= rule?.lunch;
  }
}

export const templateValidator = new TemplateValidator();
